import axios from '../api'

/**
 * API接口
 */
export default {
    // 获取应用列表
    apppushList(params) {
        return axios.post('/apppush/list', params)
    },
    // 获取应用列表
    platfromList(params) {
        return axios.post('/apppush/platfromList', params)
    },
    // 获取应用列表
    adstubList(params) {
        return axios.post('/apppush/adstubList', params)
    },
    appInfo(params) {
        return axios.post('/apppush/appInfo', params)
    },
    appDataInfo(params) {
        return axios.post('/apppush/appDataInfo', params)
    },
    appList() {
        return axios.post('/apppush/appList')
    },
    appEdit(params) {
        return axios.post('/apppush/appEdit', params)
    },
    appAdd(params) {
        return axios.post('/apppush/appAdd', params)
    },
    uploadImg(params) {
        return axios.post('/apppush/upload', params)
    },
    addAppMsg(params) {
        return axios.post('/apppush/addAppMsg', params)
    },
    delAppMsg(params) {
        return axios.post('/apppush/delAppMsg', params)
    },
    editAppMsg(params) {
        return axios.post('/apppush/editAppMsg', params)
    },
    appDel(params) {
        return axios.post("apppush/appDele", params)
    },

    addAppWpath(params) {
        return axios.post("apppush/addAppWpath", params)
    },
    delAppWpath(params) {
        return axios.post('/apppush/delAppWpath', params)
    },
    editAppWpath(params) {
        return axios.post('/apppush/editAppWpath', params)
    },
}


// WEBPACK FOOTER //
// ./src/api/apppush/apppush.js